/* global FS */

export const getFullStoryUrl = () => {
  if (window.FS && typeof FS.getCurrentSessionURL === 'function') {
    return FS.getCurrentSessionURL(true);
  }
};
